import * as Yup from 'yup';

export const breweryAndSettingsValidationSchema = Yup.object().shape({
  name: Yup.string().required('The brewery name is required'),
  streetAddress: Yup.string().required('The street address is required'),
  city: Yup.string().required('The city is required'),
  postcode: Yup.string().required('The postcode is required'),
  settings: Yup.object().shape({
    reportEmailAddress: Yup.string().required('The email address for reports is required'),
    transferReportAdvanceDays: Yup.number().required('The number of days in advance for transfer reports is required')
  })
});



// WEBPACK FOOTER //
// ./src/validation/brewery.js